import React from 'react'
import { ExecuteOperationForModelOnPipe, ExecuteOperationOnPipe, useModelValue } from '@morningtrain/react-resources'
import PropTypes from 'prop-types'
import { Pipeline } from '@morningtrain/react-helpers'
import { observer } from 'mobx-react'
import TriggerPipelineOnDebounce from 'widgets/smartviews/partials/TriggerPipelineOnDebounce'
import moment from "moment";

function AdjustScheduleButton (props) {
  const { children, scheduleId, step, weekDay, pipes } = props

  return (
    <Pipeline>
      <TriggerPipelineOnDebounce step={step}>
        {children}
      </TriggerPipelineOnDebounce>
      <ExecuteOperationForModelOnPipe
        resourceName='shifts.schedule'
        operationName='adjust_forecast'
        data={(payload) => {
          return {
            schedule: scheduleId,
            weekday_index: weekDay,
            adjustment: payload.adjustment
          }
        }}
      />
      {pipes || (
        <ExecuteOperationOnPipe
          operationName='day_summary'
          data={{
            schedule: scheduleId
          }}
        />
      )}
    </Pipeline>
  )
}

AdjustScheduleButton.defaultProps = {
  step: 500,
  weekDay: moment().weekday()
}

AdjustScheduleButton.propTypes = {
  scheduleId: PropTypes.number.isRequired,
  step: PropTypes.number,
  weekDay: PropTypes.number
}

export default observer(AdjustScheduleButton)
